export class Menus {
    dashboard: boolean;
    createEvent: boolean;
    myEvents: boolean;
    Speaker: boolean;
    Training: boolean;
    uploadReferenceMaterial: boolean;
    manageSpeakerContent: boolean;
    myStory: boolean;
    venue: boolean;
    attendeeListing: boolean;
    myProfile: boolean;
    addExpense: boolean;
    reconcileExpense: boolean;
    reports: boolean;
    searchSpeaker: boolean;
    addSpeaker: boolean;
    searchVenue: boolean;
    addVenue: boolean; 
    upcomingEventFilter: boolean;
    notificationsFilter: boolean;
    taskFilter: boolean;
    editVenue: boolean;
}